module.exports = __webpack_public_path__ + "img/entwined.94a598b.webp";